import { createContext } from 'react';

export type InterimsTimeRangeContextProps = {
  selectedRange: { from: Date; to: Date };
  availableRange: { from: Date; to: Date };
  zoomIn: (zoomValue: number) => void;
  zoomOut: (zoomValue: number) => void;
  zoomExpand: () => void;
  moveVisibleRangeLeft: (movePercent: number) => void;
  moveVisibleRangeRight: (movePercent: number) => void;
  moveVisibleRangeTo: (newSelectedFrom: Date, newSelectedTo: Date) => void;
};

export const InterimsTimeRangeContext = createContext<InterimsTimeRangeContextProps>(
  {} as InterimsTimeRangeContextProps,
);
